const { RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    cardTitle,
    cardText,
    cardButtonText,
    cardButtonHref,
    icon,
    openModal,
  } = attributes;

  return (
    <div className="ContactUsCards__item">
      <div className="ContactUsCards__item-header">
        {icon.src && (
          <figure className="ContactUsCards__item-icon">
            <img src={icon.src} alt={icon.alt} height={icon.height} />
          </figure>
        )}

        <RichText.Content
          tagName="h4"
          value={cardTitle}
          className={`ContactUsCards__item-title ${!icon.src && 'full'}`}
        />
      </div>

      <RichText.Content
        tagName="p"
        value={cardText}
        className="ContactUsCards__item-text"
      />

      {openModal ? (
        <button className="ContactUsCards__item-button ModalForm-open">
          {cardButtonText}
        </button>
      ) : (
        <a
          {...(cardButtonHref && { href: cardButtonHref })}
          className="ContactUsCards__item-button"
        >
          {cardButtonText}
        </a>
      )}
    </div>
  );
};

export default Save;
